import { makeStyles, useTheme } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import TextField from 'Components/UI/TextField';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import React from 'react';
import { fade } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {
    paddingBottom: '0px',
    width: '100%',
    minWidth: '150px',
    '& .MuiFilledInput-root': {
      borderRadius: '8px',
      backgroundColor: 'transparent',
      border: `1px solid ${theme.palette.facet.stone700}`,
    },
    '& .MuiFormLabel-root': {
      size: '16px',
      color: `${theme.palette.facet.primaryText}`,
    },
    '& .MuiFilledInput-root.Mui-disabled': {
      backgroundColor: theme.palette.disabledBackground.main,
      border: `1px solid ${theme.palette.disabledBackground.main}`,
    },
    '& .MuiFormLabel-root.Mui-disabled': {
      color: theme.palette.facet.actionActive,
    },
    '& .MuiFormLabel-root.Mui-error': {
      color: fade(theme.palette.error.main, 0.8),
    },
    '& .MuiInputBase-input': {
      color: `${theme.palette.facet.primaryText} !important`,
      fontWeight: '400',
      size: '16px',
      // padding: '8px 4px !important',
    },
    '& .MuiInputBase-input.Mui-disabled': {
      color: `${theme.palette.facet.actionActive} !important`,
    },
    '& .MuiInputBase-root.Mui-error': {
      color: fade(theme.palette.error.main, 0.8),
      backgroundColor: fade(theme.palette.error.main, 0.3),
      '&:hover': {
        color: fade(theme.palette.error.main, 0.8),
      },
      '& .MuiInputBase-input': {
        color: fade(theme.palette.error.main, 0.8),
      },
      '& .MuiSvgIcon-root': {
        color: fade(theme.palette.error.main, 0.8),
      },
    },
  },
  input: {
    minHeight: '67px', // <--- TODO: Make a const
    color: theme.palette.facet.primaryBlue,
    background: theme.palette.facet.accentBlue20,
    borderRadius: theme.radius.md,
    fontSize: theme.typography.h4.fontSize,
    '&:hover': {
      background: theme.palette.facet.accentBlue20,
    },
  },
}));


// We cannot use the existing FDTextField because it needs to support input props for autocomplete
function FDTextField({
  value, onChange, hidden, readonly, label, helperText, placeholder, onBlur, InputProps, test, ...rest
}) {
  const theme = useTheme();
  const classes = useStyles(theme);

  return (
    <TextField
      value={value}
      onChange={onChange}
      hidden={hidden}
      label={label}
      InputLabelProps={{ shrink: true }}
      variant={'filled'}
      disabled={readonly}
      InputProps={{
        disableUnderline: true,
        readonly: false,
        className: classes.input,
        ...InputProps,
      }}
      HelperProps={{
        showHelperText: false,
      }}
      classes={{
        root: classes.root,
      }}
      placeholder={placeholder}
      onBlur={onBlur}
      size={'small'}
      test={test}
      {...rest}
    />
  );
}

FDTextField.propTypes = {
  readonly: 'false',
  hidden: 'false',
  onChange: noop,
  onBlur: noop,
  value: undefined,
  InputProps: {},
  placeholder: '',
  test: '',
  label: '',
  helperText: '',
};

FDTextField.defaultProps = {
  readonly: PropTypes.bool,
  hidden: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  value: PropTypes.string,
  InputProps: PropTypes.object,
  placeholder: PropTypes.string,
  test: PropTypes.string,
  label: PropTypes.string,
  helperText: PropTypes.string,
};

export default FDTextField;
